export default {
    path: "/test",
    name: "test",
    children: [
        {
            path: "test-step-1",
            name: "test-step-1",
            component: () => import('@/views/Test/Step1.vue')
//            component: () => import('@/views/FakeLP.vue')
        },
        {
            path: "test-step-2",
            name: "test-step-2",
            component: () => import('@/views/Test/Step2.vue')
        },
        {
            path: "test-step-3",
            name: "test-step-3",
            component: () => import('@/views/Test/Step3.vue')
        },
        {
            path: "test-step-4",
            name: "test-step-4",
            component: () => import('@/views/Test/Step4.vue')
        },
        {
            path: "test-step-5",
            name: "test-step-5",
            component: () => import('@/views/Test/Step5.vue')
        },
        {
            path: "test-step-6",
            name: "test-step-6",
            component: () => import('@/views/Test/Step6.vue')
        },
        {
            path: "test-finish/:id",
            name: "test-finish",
            component: () => import('@/views/Test/Finish.vue')
        },
        {
            path: "created",
            name: "created",
            component: () => import('@/views/Test/Created.vue')
        }
    ]
}
